import { Dispatch, SetStateAction } from 'react';
import { IHomeRecruiterAnalytics, saveRecruiterAnalytics } from 'wisestep-api';

import { failed, success } from '../../utils/NotificationMessages';
import { INotification } from '../../utils/NotificationStore';

export const defaultPinRecruiterAnalyticsData = {
  id: '',
  email: '',
  workspaceId: '',
  pinned: false,
};

export const pinRecruiterAnalytics = async (
  setPinRecruiterAnalyticsData: Dispatch<SetStateAction<IHomeRecruiterAnalytics>>,
  setPinAnalyticsStatus: Dispatch<SetStateAction<boolean>>,
  setNotification: (notification: INotification) => void,
  pinRecruiterAnalyticsData: IHomeRecruiterAnalytics,
  pinAnalyticsStatus: boolean
) => {
  try {
    const res = await saveRecruiterAnalytics({
      ...pinRecruiterAnalyticsData,
      pinned: !pinAnalyticsStatus,
    });
    setPinRecruiterAnalyticsData(res.data);
    setPinAnalyticsStatus(res.data?.pinned);
    setNotification(
      success(
        `Recruiter Analytics ${
          pinRecruiterAnalyticsData.pinned ? 'unpinned from' : 'pinned to'
        } home page successfully!!`
      )
    );
  } catch {
    setNotification(
      failed(
        `error occured while ${
          pinRecruiterAnalyticsData.pinned ? 'pinning' : 'unpinning'
        } the recruiter analytics`
      )
    );
  }
};
